import { withErrorBoundary } from "@sentry/nextjs";
import Link from "next/link";
import { FC, useState } from "react";
import styled from "styled-components";
import { useFeatureFlags } from "lib/featureFlags/FeatureFlagProvider";
import { FEATURE_FLAG_KEYS, FeatureFlags } from "lib/featureFlags/flags";
import { ToggleSwitch } from "./ToggleSwitch";

type Props = {};

export const Preview: FC<Props> = withErrorBoundary(() => {
  const featureFlags = useFeatureFlags() as FeatureFlags;
  const [switchStates, setSwitchStates] = useState<Record<string, boolean>>(featureFlags);

  const handleToggleChange = async (name: string, value: boolean) => {
    const newSwitchStates = {
      ...switchStates,
      [name]: value,
    };

    setSwitchStates(newSwitchStates);

    try {
      const url = `/api/preview?${name}=${~~value}`;

      const resp = await fetch(url);

      if (!resp.ok) {
        throw new Error(resp.statusText);
      }

      window.location.reload();
    } catch (e) {
      console.error("error setting ", name, " to: ", value, e);
    }
  };

  const showFeatureToggles = (() => {
    // display all configurable feature flags

    return FEATURE_FLAG_KEYS.map((featureFlag) => {
      return (
        <ToggleSwitch
          key={featureFlag}
          name={featureFlag}
          checked={switchStates[featureFlag]}
          onChange={handleToggleChange}
        />
      );
    });
  })();

  return (
    <StyledPreview className="Color_onPrimary Font_16_22_600">
      <span>Preview mode is enabled</span>
      <span>With these flags: </span>
      {showFeatureToggles}
      <Link href="/api/exit-preview" prefetch={false}>
        Exit preview mode
      </Link>
    </StyledPreview>
  );
}, {});

const StyledPreview = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: start;
  bottom: 16px;
  right: 16px;
  z-index: 9999;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: 8px;
  opacity: 0.48;
  max-height: 300px;
  overflow: scroll;

  &:hover {
    opacity: 1;
  }
`;
